export const UNAUTH = 'UNAUTH';
export const AUTH_ALLOW = 'AUTH_ALLOW';
export const AUTH_DENY = 'AUTH_DENY';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';



// WEBPACK FOOTER //
// ./src/constants/authStatus.js